






































































































































import { Component, Vue, Watch, Provide, Prop } from "vue-property-decorator";
import dataCenter from '@/request/requestIndex/index'
import { ReportStatus } from "@/pbjs/xcommon/enum_pb";
@Component({
  name: "riskReporting"
})
export default class RiskReporting extends Vue {
  @Prop() orderId!: any[]; // 订单id
  @Prop() caselevel!: any[]; // 联系人关系列表
  @Prop() selectionList!: any[]; // 还款渠道列表
  @Prop() repayReportsStatus!: any[]; // 上报状态
  @Provide() enumReportsStatus: any = ReportStatus.REPORT_STATUS_CAN_UPDATE; // 可以上传上报状态
  @Provide() private systemInfo:any=localStorage.getItem("systemInfo")
  @Provide() private RepaymentChannelsOp:any=[
    {name:'jazzcash',value:'1'},
    {name:'easypaisa',value:'2'},
    {name:'bank',value:'3'},
    {name:'other',value:'4'},
  ]
  @Provide() private repayReportForm: any = {
    textarea: '',
    TrxID: '',
    Amount: null,
    paymentTime: '',
    RepaymentChannels:'',
    RepaymentChannelsothers:'',
  };
  // @Watch("selectionList")
  // onselectionChange(val: number | null){
     
  // }
  // @Provide() private rules: any = {
  //    name: [
  //         { required: true, message: '请输入活动名称', trigger: 'blur' },
  //         { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
  //       ],
  // };
  @Provide() fileList: any[] = [];
  @Provide() fileListId: any[] = [];
  @Provide() private msg: any = this.$message;
  @Provide() private isSaved: any = false;
  @Provide() private isUpdate: any = false;
  @Provide() private selectInput: any = false;
  
  @Provide() private country: any = localStorage.getItem("country"); // 国家，字段差异化展示
  private created() {
  }
  //选择其他
  private selectOther(val:any) {
    this.selectInput=val==99?true:false
  }
  
  // 点击关闭弹窗
  private hideContainer() {
    this.$emit("returnRiskReport", {
      isShow: true
    });
  }
   // getStatusLabel
  private getStatusLabel(status: any) {
    let label = '';
    switch (status) {
      case 0:
        label = 'ticket.abnormal'
        break;
      case 1:
        label = 'ticket.repayStatus1'
        break;
      case 2: // 可上传还款问题
        label = 'ticket.repayStatus2' 
        break;
      case 3:
        label = 'ticket.repayStatus0'
        break;
      default:
        label = 'ticket.repayStatus0'
        break;
    }
    return label;
  }
  // 还款问题校验
  private saveRiskReportJudgement() {
    if (this.repayReportForm.RepaymentChannels=="99") {
      if(this.country === 'en') {
      if (
        this.repayReportForm.TrxID!==''&&
        this.repayReportForm.Amount!==""&&
        this.fileList.length > 0 &&
         this.repayReportForm.paymentTime !== ''
        //  liugaoyang 线上问题暂时注释
         &&
         this.repayReportForm.RepaymentChannels!==''&&
         this.repayReportForm.RepaymentChannelsothers!==''
       ) {
        return true;
      }else{
        return false;
      }
      
    } else {
      if (
              this.repayReportForm.paymentTime != '' &&
              this.repayReportForm.textarea != '' &&
              this.fileList.length > 0
              //  liugaoyang 线上问题暂时注释
              &&
         this.repayReportForm.RepaymentChannels!==''&&
         this.repayReportForm.RepaymentChannelsothers!==''
      ) {
        this.isSaved = true;
        return true;
      }
      return false;
    }
    }else{
      if(this.country === 'en') {
      if (
        this.repayReportForm.TrxID!==''&&
        this.repayReportForm.Amount!==""&&
        this.fileList.length > 0 &&
         this.repayReportForm.paymentTime !== ''
         //  liugaoyang 线上问题暂时注释
         &&
         this.repayReportForm.RepaymentChannels!==''
       ) {
        return true;
      }else{
        return false;
      }
      
    } else {
      if (
              this.repayReportForm.paymentTime != '' &&
              this.repayReportForm.textarea != '' &&
              this.fileList.length > 0
              //  liugaoyang 线上问题暂时注释
              &&
         this.repayReportForm.RepaymentChannels!==''
      ) {
        this.isSaved = true;
        return true;
      }
      return false;
    }
    }
    
    
  }
  private inputFuction(e: any, type: string) {
    // let a=''
    // Array.from(e).forEach((item:any) => {
    //   a=item.replace(/[^0-9]/, '')
    // });
    
    
    // this.repayReportForm.TrxID = e.replace(/[^0-9]/g, '')
    // if (!/^[0-9]*$/.test(this.repayReportForm.TrxID)) {
    //   this.msg({
    //           type: "error",
    //           message: 'Please enter number'
    //         });
      
    // }
    switch(type) {
      case 'TrxID':
        this.repayReportForm.TrxID = e.replace(/[^0-9]/g, '')
        break;
      case 'Amount':
        this.repayReportForm.Amount = e.replace(/[^0-9]/g, '')
        break;
    }
  }
  private inputFuction1(e: any, type: string) {
    this.repayReportForm.Amount = e.replace(/[^0-9]/, '')
    // if (!/^[0-9]*$/.test(this.repayReportForm.Amount)) {
    //   this.msg({
    //           type: "error",
    //           message: 'Please enter number'
    //         });
      
    // }
    switch(type) {
      case 'TrxID':
        this.repayReportForm.TrxID = e.replace(/[^0-9]/g, '')
        break;
      case 'Amount':
        this.repayReportForm.Amount = e.replace(/[^0-9]/g, '')
        break;
    }
  }
  // 提交还款问题
  private async saveRiskReport() {
    let that = this;
    if (that.saveRiskReportJudgement()) {
        let opt = this.country === 'en' ? {
          setOrderid: that.orderId + '',
          setBucket: that.caselevel + '',
          setTrxid: that.repayReportForm.TrxID + '',
          setPaymentdate: that.repayReportForm.paymentTime,
          setAmount: Number(that.repayReportForm.Amount),
          setRemarks: that.repayReportForm.textarea,
          setImagesList: that.fileListId,
          setRepaychanneltype:that.repayReportForm.RepaymentChannels,
          setOtherrepaychannel:that.repayReportForm.RepaymentChannelsothers,
        } : {
          setOrderid: that.orderId + '',
          setBucket: that.caselevel + '',
          // setTrxid: that.repayReportForm.TrxID + '',
          setPaymentdate: that.repayReportForm.paymentTime,
          // setAmount: Number(that.repayReportForm.Amount),
          setRemarks: that.repayReportForm.textarea,
          setImagesList: that.fileListId,
          setRepaychanneltype:that.repayReportForm.RepaymentChannels,
          setOtherrepaychannel:that.repayReportForm.RepaymentChannelsothers,
        }
        dataCenter.commonApi.reportRepaymentIssue(opt).then((res: any)=> {
        if (res.commonout.code === 0) {
          if(res.isexist) {
            this.msg({
              type: "error",
              message: 'Submit failed，already exist issue for same loan.'
            });
            that.isSaved = false;
          }else {
            this.msg({
              type: "success",
              message: 'Submit success.'
            });
          }
          this.hideContainer();
        }
      },(oError: any)=> {
        that.isSaved = false;
      })
    } else {
      this.isSaved = false;
      this.$message({
        type: "error",
        message: "pls check the form value!"
      });
    }
  }

  private changeInput(val: any, list:[]) {
    let that = this;
    let reg = /png|jpg|jpeg/g;
    if(/png|jpg|jpeg/g.test(val.raw.type) && val.raw.size <= 500000) {
      that.isUpdate = true;
      let reader:any = new FileReader();
      reader.readAsArrayBuffer(val.raw);
      reader.onload = function () {
        let file = new Uint8Array(this.result);
        dataCenter.commonApi.reportRepaymentImg({
          setRelatedid: that.orderId + '',
          setContenttype: val.raw.type,
          setExten: (val.raw.name.match(/\.[a-zA-Z]+$/g))[0],
          setData: file,
        }).then((res: any)=> {
          if (res.commonout.code === 0) {
            that.isUpdate = false;
            that.fileList = list;
            that.fileListId.push(res.resourceid)
          }else {
            let listC = list;
            listC.pop();
            that.fileList = listC;
          }
        },(oError:any)=> {
          that.isUpdate = false;
          let listC = list;
          listC.pop();
          that.fileList = listC;
        })
      }
    }else {
      let listC = list;
      listC.pop();
      this.fileList = listC;
      that.$message({
        type: "error",
        message: "jpg/png only,less than 500k"
      });
    }
  }
  private onExceed() {
    this.$message({
      type: "error",
      message: "should be less than 3 files."
    });
  }
  private hideMsk() {
    if(this.repayReportForm.textarea == '' && this.repayReportForm.paymentTime == ''  && this.fileList.length === 0) {
      this.hideContainer();
    }else {
      this.$confirm('We will delete all messages if you leave,are you sure?', '', {
        confirmButtonText: 'yes',
        cancelButtonText: 'cancel',
        type: 'warning'
      }).then(() => {
        this.hideContainer();
      }).catch(() => {

      });
    }
  }
}
